import { Component } from '@angular/core';

@Component({
  selector: 'app-adddeliveryvehicle',
  templateUrl: './adddeliveryvehicle.component.html',
  styleUrl: './adddeliveryvehicle.component.scss'
})
export class AdddeliveryvehicleComponent {

}
